

import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import './App.css';

import { LanguageProvider } from './componentes/LanguageContext';

import Home from './pages/HomePage/home';
import Membros from './pages/SobreNos/membros/membros';
import Contatos from './pages/SobreNos/contato/contatos';
import SobreNos from './pages/SobreNos/Sobrenos/sobrenos';
import Noticias from './pages/Noticias/noticias';
import Capacitacoes from './pages/Capacitacoes/capacitacoes';
import Artigos from './pages/Resultados/artigos/artigos';
import Ebooks from './pages/Resultados/ebooks/ebooks';
import AnaisConpeex from './pages/Resultados/anaisConpeex/anaiseventos';
import AnaisSBPQO from './pages/Resultados/anaisSBPQO/anaiseventos';
import Dissertacoes from './pages/Resultados/Dissertacoes/dissertacoes';
import Producao from './pages/Resultados/Producao/producao';
import Instagram from './pages/Instagram/instagram';
import Privacidade from './pages/Privacidade/privacidade';

function App() {
  return (
    <LanguageProvider> 
      <Router basename="/portal">
        <div className="App">
          <Routes>
            <Route path="/" element={<Navigate to="/home" />} />
            <Route path="/home" element={<Home />} /> 
            <Route path="/noticias" element={<Noticias />} />
            <Route path="/capacitacoes" element={<Capacitacoes />} />
            <Route path="/proposito" element={<SobreNos />} />
            <Route path="/membros" element={<Membros />} />
            <Route path="/contatos" element={<Contatos />} />
            <Route path="/artigos" element={<Artigos />} />
            <Route path="/ebooks" element={<Ebooks />} />
            <Route path="/anaisconpeex" element={<AnaisConpeex />} />
            <Route path="/anaissbpqo" element={<AnaisSBPQO />} />
            <Route path="/dissertacoes" element={<Dissertacoes />} />
            <Route path="/producao" element={<Producao />} />
            <Route path="/instagram" element={<Instagram />} />
            <Route path="/privacidade" element={<Privacidade />} />
          </Routes>
        </div>
      </Router>
    </LanguageProvider>
  );
}

export default App;
